import {
  // createAction,
  handleActions
} from "redux-actions";
import {
  SET_LOADING,
  SET_PREV_PAGE_FILTERS,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FIRST_TIME_RIDERS_SUCCESS
} from "./firstRidersSagas";

export const initialState = {
  initRequest: false,
  prevPageFilters: { prevDate: null },
  firstTimeRiders: {
    closingBreakdown: []
  },
  initialized: false,
  isLoading: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_PREV_PAGE_FILTERS]: (state, action) => ({
      ...state,
      prevPageFilters: { ...action.payload }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      initRequest: true
    }),
    [FETCH_FIRST_TIME_RIDERS_SUCCESS]: (state, action) => ({
      ...state,
      initialized: action.payload.initialized || state.initialized,
      firstTimeRiders: action.payload || state.firstTimeRiders
    })
  },
  initialState
);
